<div class="vid-reg-forma-style"  *ngIf="!sharedDataService.getKlaidos()">
  <label class="title">{{ 'title.gii.registracijos' | translate }}</label>
  <div class="col filter-box-style">
    <div class="row">
      <div class="col">
        <kendo-label [for]="subjektoTipas" text="{{ 'label.subjekto.tipas' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #subjektoTipas
          fillMode="none"
          class="transparent-background"
          [data]="subjektoTipasList"
          [textField]="'text'"
          [valueField]="'value'"
          [(value)]="selectedSubjektoTipas">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="kodas" text="{{ 'label.kodas' | translate }}"></kendo-label>
        <kendo-textbox
          [clearButton]="true"
          [(value)]="selectedKodas"
          #kodas
        ></kendo-textbox>
      </div>
      <div class="col">
        <kendo-label [for]="pavadinimas" text="{{ 'label.pavadinimas' | translate }}"></kendo-label>
        <kendo-textbox
          [clearButton]="true"
          [(value)]="selectedPavadinimas"
          #pavadinimas
        ></kendo-textbox>
      </div>
    </div>
    <div class="row"  style="padding-top: 10px">
      <div class="col">
        <kendo-label [for]="srautas" text="{{ 'label.srautas' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #srautas
          fillMode="none"
          class="transparent-background"
          [data]="srautaiList"
          [textField]="'text'"
          [valueField]="'value'"
          [(value)]="selectedSrautas">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="busena" text="{{ 'label.busena' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #busena
          fillMode="none"
          class="transparent-background"
          [data]="busenosList"
          [textField]="'text'"
          [valueField]="'value'"
          [(value)]="selectedBusena">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="atsakBudas" text="{{ 'label.atsak.budas' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #atsakBudas
          fillMode="none"
          class="transparent-background"
          [data]="atsakBudasList"
          [textField]="'text'"
          [valueField]="'value'"
          [(value)]="selectedAtsakBudas">
          <ng-template kendoDropDownListNoDataTemplate>
            {{ 'label.duomenu.nera' | translate }}
          </ng-template>
        </kendo-dropdownlist>
      </div>
    </div>
    <div class="row"  style="padding-top: 10px">
      <div class="col">
        <kendo-label [for]="rikiuotiPagal" text="{{ 'label.rikiuoti.pagal' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #rikiuotiPagal
          fillMode="none"
          class="transparent-background"
          [textField]="'text'"
          [valueField]="'value'"
          [data]="orderBy"
          [(value)]="selectedOrderBy"
          (valueChange)="filterOrderBy2(this.selectedOrderBy.value, this.selectedOrderBy3.value)">
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="rikiuotiPagal2" text="{{ 'label.tada.pagal' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #rikiuotiPagal2
          fillMode="none"
          class="transparent-background"
          [textField]="'text'"
          [valueField]="'value'"
          [data]="orderBy2"
          [(value)]="selectedOrderBy2"
          (valueChange)="filterOrderBy3(this.selectedOrderBy.value, this.selectedOrderBy2.value)">
        </kendo-dropdownlist>
      </div>
      <div class="col">
        <kendo-label [for]="rikiuotiPagal3" text="{{ 'label.tada.pagal' | translate }}"></kendo-label>
        <kendo-dropdownlist
          #rikiuotiPagal3
          fillMode="none"
          class="transparent-background"
          [textField]="'text'"
          [valueField]="'value'"
          [data]="orderBy3"
          [(value)]="selectedOrderBy3">
        </kendo-dropdownlist>
      </div>
    </div>
    <div style="float: right;">
      <kendo-button class="filter-button" kendoButton themeColor="primary" fillMode="outline" style="margin-right: 10px" (click)="openExportDialog()">
        {{ 'button.eksportuoti.duomenis' | translate }}
      </kendo-button>
      <kendo-button class="filter-button" kendoButton themeColor="primary" fillMode="outline" (click)="onFilterClicked()">
        {{ 'button.filtruoti' | translate }}
      </kendo-button>
    </div>
  </div>
  <div class="col">
    <div>
      <kendo-grid #giiRegGrid
                  [data]="view | async"
                  [selectable]="true"
                  (cellClick)="onRowSelect($event.dataItem)"
                  [class]="'selectable-grid'"
                  [loading]="giiRegService.loading"
                  [pageable]="{
                      pageSizes: [20, 50, 100]
                      }"
                  [pageSize]="pageSize"
                  [skip]="state.skip"
                  (pageChange)="onPageChanged($event)">
        <kendo-grid-column field="tipas" title="{{ 'grid.title.subjekto.tipas' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ ('label.tipas.' + dataItem.tipas) | translate }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="kodas" title="{{ 'grid.title.kodas' | translate }}" [width]="15"></kendo-grid-column>
        <kendo-grid-column field="pavadinimas" title="{{ 'grid.title.pavadinimas' | translate }}" [width]="15"></kendo-grid-column>
        <kendo-grid-column field="srautas" title="{{ 'grid.title.srautas' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.srautasPavadinimas | translateName }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="regData" title="{{ 'grid.title.reg.data' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.regData | date: 'yyyy-MM-dd' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="atsakBudas" title="{{ 'grid.title.atsak.budas' | translate }}" [width]="20">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.atsakPavadinimas | translateName }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="isregData" title="{{ 'grid.title.isreg.data' | translate }}" [width]="20">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ dataItem.isregData | date: 'yyyy-MM-dd' }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="busena" title="{{ 'grid.title.busena' | translate }}" [width]="15">
          <ng-template kendoGridCellTemplate let-dataItem>
            {{ 'label.busena.' + dataItem.busena | translate }}
          </ng-template>
        </kendo-grid-column>
        <kendo-grid-column field="adresas" title="{{ 'grid.title.adresas' | translate }}" [width]="15"></kendo-grid-column>
        <kendo-grid-messages
          [pagerItemsPerPage]="'label.irasai.puslapyje' | translate"
          [pagerItems]="'label.irasu' | translate"
          [pagerOf]="'label.is' | translate"
          [pagerPage]="'label.puslapis' | translate"
          [noRecords]="'label.sarasas.tuscias' | translate"
        >
        </kendo-grid-messages>
      </kendo-grid>
    </div>
  </div>
  <kendo-window
    *ngIf="this.showExportDialog"
    (close)="this.closeExportDialog()"
    [minWidth]="250"
    [width]="650"
    themeColor="primary"
    title="{{ 'title.duomenu.eksportas' | translate }}"
  >
    <div>
      <kendo-label [for]="ataskaitosPasirinkimas" text="{{ 'label.pasirinkti.ataskaita' | translate }}"></kendo-label>
      <kendo-dropdownlist
        #ataskaitosPasirinkimas
        fillMode="none"
        [data]="reports"
        [textField]="'name'"
        [valueField]="'id'"
        [value]="3"
        [valuePrimitive]="true"
      >
        <ng-template kendoDropDownListItemTemplate let-dataItem>
          {{ dataItem.name | translate }}
        </ng-template>

        <ng-template kendoDropDownListValueTemplate let-dataItem>
          {{ dataItem?.name | translate }}
        </ng-template>
      </kendo-dropdownlist>
    </div>
    <div *ngIf="ataskaitosPasirinkimas.value == 3">
      <div class="mt-3">
        <kendo-label [for]="regDataNuo" text="{{ 'apskaita.registracijosDataNuo' | translate }}"></kendo-label>
        <kendo-datepicker format="yyyy-MM-dd"
                          [format]="'yyyy-MM-dd'"
                          [(ngModel)]="ataskaitosParametrai.registracijosDataNuo"
                          #regDataNuo>
          <kendo-datepicker-messages
            today="{{ 'label.siandien' | translate }}"
            toggle="{{ 'label.isskleisti.kalendoriu' | translate }}"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </div>
      <div class="mt-3">
        <kendo-label [for]="regDataIki" text="{{ 'apskaita.registracijosDataIki' | translate }}"></kendo-label>
        <kendo-datepicker format="yyyy-MM-dd"
                          [format]="'yyyy-MM-dd'"
                          [(ngModel)]="ataskaitosParametrai.registracijosDataIki"
                          #regDataIki>
          <kendo-datepicker-messages
            today="{{ 'label.siandien' | translate }}"
            toggle="{{ 'label.isskleisti.kalendoriu' | translate }}"
          ></kendo-datepicker-messages>
        </kendo-datepicker>
      </div>
    </div>
    <div class="k-form-buttons" style="padding-top: 20px">
      <div style="flex-grow: 1;"></div>
      <div style="float: right;">
        <kendo-button kendoButton themeColor="error" fillMode="outline" style="margin-right: 10px;" (click)="closeExportDialog()">
          {{ 'button.atsaukti' | translate }}
        </kendo-button>
        <gii-reports [ataskaitosParametrai]="ataskaitosParametrai" [ataskId]="ataskaitosPasirinkimas.value"></gii-reports>
      </div>
    </div>
  </kendo-window>
</div>
<div *ngIf="sharedDataService.getKlaidos()" class="error-message-red">
  {{ this.sharedDataService.getKlaidos() | translate}}
</div>
